import React from 'react'

import Welcome from '../Welcome'
import Question from '../Question'
import Outcome from '../Outcome'

import 'normalize.css'
import 'font-awesome/css/font-awesome.min.css'
import './general.css'
import classes from './styles'

function getCurrentPage({ isGameStarted, isFailOutcomeDisplayed, isWinOutcomeDisplayed }) {
  if (!isGameStarted) return <Welcome />
  if (isFailOutcomeDisplayed) return <Outcome />
  if (isWinOutcomeDisplayed) return <Outcome />

  return <Question />
}

const App = (props) => {
  const CurrentPage = getCurrentPage(props)

  return (
    <div
      className={classes.app}
    >
      <img className={[classes.leftTop, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
      <img className={[classes.rightTop, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
      <img className={[classes.leftBottom, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>
      <img className={[classes.rightBottom, classes.angle].join(' ')} src="https://10years.lifehacker.ru/static/images/rounded.svg" alt=""/>

      {CurrentPage}
    </div>
  )
}

App.propTypes = {
  isGameStarted: React.PropTypes.bool.isRequired,
  isFailOutcomeDisplayed: React.PropTypes.bool.isRequired,
  isWinOutcomeDisplayed: React.PropTypes.bool.isRequired,
}

export default App



// WEBPACK FOOTER //
// ./src/components/App/App.jsx